(function ($) {
// Labels
    function set_active() {
        if ($(this).val() !== "") {
            $(this).closest(".form-element").addClass('active')
        } else {
            $(this).closest(".form-element").removeClass('active')
        }
    }

    function init_active_fields(){
        $("input, select, textarea").each(set_active)
        $("input, select, textarea").on("change", set_active)
    }

    init_active_fields()
    $(document).gp_ready(init_active_fields)

})(jQuery);